/**
 * Inline Video Module (formerly Floating Video)
 * @module floatingVideo
 */

import $ from 'jquery';
import './custom-video-player';
import registerJQueryPlugin from '../../lib/register-jquery-plugin';
import mergeOptions from '../../lib/merge-options';

// Expose the function as a jQuery plugin for ease of use
export const PLUGIN_NAME = 'floatingVideo';
export const DEFAULTS = {
  videoMuted: true,
  // Renders the mute/volume button (flag is inverted). Defaulted here so the
  // gallery gets it regardless of which init path runs — one caller invokes
  // .floatingVideo() with no options. [UX-20630]
  hideMute: true,
  $originalTrigger: null
};

const buildVideo = (videoUrl, videoPosterUrl, aspectRatio) => $(`
  <video class="u-full-width" ${aspectRatio ? `style="aspect-ratio:${aspectRatio};"` : ''} poster="${videoPosterUrl}" playsinline="playsinline" loop muted>
    <source src="${videoUrl}" type="video/mp4">
  </video>
`);

/**
 * Replaces the trigger's thumbnail with an inline video and wires it up to
 * the custom video player. The video adopts the placeholder image's aspect
 * ratio so its height matches surrounding gallery image slides.
 * @param  {jQuery} $el - trigger element
 * @param  {Object} options - Any options provided upon initialization
 */
const renderInlineVideo = ($el, options) => {
  const videoUrl = $el.data('videoUrl');
  const videoPosterUrl = $el.data('videoPosterUrl');
  const $thumbnail = $el.find('figure');
  const $img = $thumbnail.find('img');

  let aspectRatio;
  if ($img.length) {
    const w = $img.attr('width');
    const h = $img.attr('height');
    if (w && h) aspectRatio = `${w}/${h}`;
  }

  const $video = buildVideo(videoUrl, videoPosterUrl, aspectRatio);

  if ($thumbnail.length) {
    $thumbnail.replaceWith($video);
  } else {
    $el.prepend($video);
  }

  $video.customVideoPlayer(options);
};

/**
 * Initializes floatingVideo
 * @param {HTMLElement} el - trigger element with data-video-url and data-video-poster-url
 * @param {Object} options - Options used for wiring up the video
 * @see DEFAULTS
 */
export default function floatingVideo(el, options = {}) {
  const $el = $(el);
  const opts = mergeOptions(DEFAULTS, options, $el);
  opts.$originalTrigger = $el;

  renderInlineVideo($el, opts);

  return {};
}
registerJQueryPlugin(PLUGIN_NAME, floatingVideo);


// WEBPACK FOOTER //
// ./styleguide/src/assets/modules/abtest/floating-video.js